<div class="inner-content">
    <div class="wrapper">
        <div class="image-wrapper">
            <img src="assets/images/app_updates.png" alt="app updates">
        </div>
        <div class="text" [innerHTML]="this.title|transloco"></div>


        <div class="btn-wrapper">
            <button class="btn green-btn" (click)="openUrl()"> {{ this.messageNowBtn|transloco }}</button>

            <button class="btn  btn-primary" (click)="close()" *ngIf="!isMandatory"> {{ this.messageAfterBtn|transloco }}</button>
        </div>


    </div>


</div>
